export const acortarTexto = ({texto='', num}) => {

    if (!texto) {
        return ''
    }

    let numero = texto.length
    let final = ''
    if (numero > num){
        numero = num - 5
        final = '...'
    }
    let text = texto.substring(0, numero)

    return text + final

}